export default __webpack_public_path__ + "media/images/dashboard_icons/dynamic-rsvps-7860786741b87b92f5ce5c7acd40b286.svg";